import React from 'react';

function Test() {
  return (
    <h1>Error page</h1>
  );
}

export default Test;
